import { render, staticRenderFns } from "./regily-manager.vue?vue&type=template&id=315191ad&"
import script from "./regily-manager.vue?vue&type=script&lang=ts&"
export * from "./regily-manager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "regily-manager.vue"
export default component.exports